// Filters

function toggleSelectMenu() {
    document.querySelector('.qr-video-info__select-selected').classList.toggle('qr-video-info__select-selected-active');
    document.querySelector('.qr-video-info__select-items').classList.toggle('qr-video-info__select-hide');
}

function selectItem(event) {
    const value = event.target.getAttribute('data-value');
    const videos = document.querySelectorAll('.qr-video-info__video-item');
    document.querySelector('.qr-video-info__select-selected span').textContent = event.target.textContent;
    document.querySelector('.qr-video-info__select-selected').classList.remove('qr-video-info__select-selected-active');
    document.querySelector('.qr-video-info__select-items').classList.add('qr-video-info__select-hide');
    document.getElementById('tag-filter').value = value;
    
    pauseOtherVideos('', videos);
    filterBlocksByTag();
}

function filterBlocksByTag() {
    const selectedTag = document.getElementById('tag-filter').value;
    document.querySelectorAll('.qr-video-info__video-card').forEach(block => {
        block.style.display = (selectedTag === 'all' || block.getAttribute('data-tag') === selectedTag) ? 'block' : 'none';
    });
}

function initializeCustomSelect() {
    const firstOption = document.querySelector('.qr-video-info__select-item');
    document.querySelector('.qr-video-info__select-selected span').textContent = firstOption.textContent;
    document.getElementById('tag-filter').value = firstOption.getAttribute('data-value');

    document.querySelector('.qr-video-info__select-selected').addEventListener('click', toggleSelectMenu);
    document.querySelectorAll('.qr-video-info__select-item').forEach(item => {
        item.addEventListener('click', selectItem);
    });

    document.addEventListener('click', (e) => {
        if (!e.target.matches('.qr-video-info__select-selected')) {
            document.querySelector('.qr-video-info__select-selected').classList.remove('qr-video-info__select-selected-active');
            document.querySelector('.qr-video-info__select-items').classList.add('qr-video-info__select-hide');
        }
    });

    filterBlocksByTag();
}  

// Video block
  
function initializePlayButtons() {
    const videoContainers = document.querySelectorAll('.qr-video-info__video-container');

    videoContainers.forEach(container => {
        const video = container.querySelector('video');
        const playButton = container.querySelector('.qr-video-info__play-btn');

        playButton.addEventListener('click', () => {
            playVideo(video, playButton);
        });

        video.addEventListener('pause', () => {
            showPlayButton(playButton);
            hideControls(video);
        });

        video.addEventListener('ended', () => {
            showPlayButton(playButton);
            hideControls(video);
        });
    });
}

function handleVideoPlay() {
    const videos = document.querySelectorAll('.qr-video-info__video-item');

    videos.forEach(video => {
        video.addEventListener('play', () => {
            pauseOtherVideos(video, videos);
            showControls(video);
        });
    });
}

function playVideo(video, playButton) {
    video.play();
    hidePlayButton(playButton);
}

function pauseOtherVideos(currentVideo, videos) {
    videos.forEach(video => {
        if (video !== currentVideo) {
            video.pause();
            video.currentTime = 0;
            hideControls(video);

            const otherPlayButton = video.closest('.qr-video-info__video-container').querySelector('.qr-video-info__play-btn');
            showPlayButton(otherPlayButton);
        }
    });
}

function hidePlayButton(button) {
    button.style.display = 'none';
}

function showPlayButton(button) {
    button.style.display = 'block';
}

function showControls(video) {
    video.controls = true;
}

function hideControls(video) {
    video.controls = false;
}


document.addEventListener('DOMContentLoaded', function() {
    initializeCustomSelect();
    initializePlayButtons();
    handleVideoPlay();
});